var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.0001L11 15.0001M11 15.0001L15 11.0001M11 15.0001V5.80006C11 4.40935 11 3.714 10.4495 2.93546C10.0837 2.41818 9.03058 1.77974 8.40278 1.69468C7.45789 1.56666 7.09907 1.75384 6.38143 2.1282C3.18333 3.79649 1 7.14331 1 11.0001C1 16.5229 5.47715 21.0001 11 21.0001C16.5228 21.0001 21 16.5229 21 11.0001C21 7.29865 18.989 4.06693 16 2.33788",
    stroke: "#224A91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownloadBlue);
export default __webpack_public_path__ + "static/media/circle-download-blue.8290d65e06eb6faf4d7fb4e1d8fa3d47.svg";
export { ForwardRef as ReactComponent };